"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const WHY_CHOOSE_BASE = "/image/new-version/fabrication/metal-stamping/why-choose";

const CARDS = [
	{
		keyPrefix: "whyChooseCard1",
		image: `${WHY_CHOOSE_BASE}/expert-engineering-collaboration.webp`,
	},
	{
		keyPrefix: "whyChooseCard2",
		image: `${WHY_CHOOSE_BASE}/scalable-production-solutions.webp`,
	},
	{
		keyPrefix: "whyChooseCard3",
		image: `${WHY_CHOOSE_BASE}/integrated-project-management.webp`,
	},
] as const;

export default function MetalStampingWhyChoose() {
	const t = useTranslations("new-stamping");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("whyChooseTitle")}
					</h2>
				</header>

				<div className="overflow-hidden bg-white">
					<div className="grid grid-cols-1 lg:grid-cols-3">
						{CARDS.map((card) => (
							<article key={card.keyPrefix} className="px-6 text-center sm:px-7 md:px-8">
								<div className="relative mx-auto mb-4 aspect-[4/2.3] w-full max-w-md overflow-hidden bg-[#f5f7fa] sm:mb-5">
									<Image
										src={card.image}
										alt={t(`${card.keyPrefix}Alt`)}
										fill
										className="object-cover"
										sizes="(max-width: 1024px) 100vw, 33vw"
									/>
								</div>
								<h3 className="mb-2 text-lg font-bold text-black sm:mb-3 sm:text-xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</article>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
